export default color => {
  if (!color) {
    return '';
  }
  return parseInt(color.replace('#', ''), 16) > 0xffffff / 2 ? false : true;
};
